import { render, staticRenderFns } from "./MoveObject.vue?vue&type=template&id=7e84d15d&scoped=true&"
import script from "./MoveObject.vue?vue&type=script&lang=js&"
export * from "./MoveObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e84d15d",
  null
  
)

export default component.exports